export const groupConsecutive = (items, keyOf, groupableOf) => {
  const groups = []
  items.forEach(item => {
    const groupable = groupableOf ? groupableOf(item) : true
    const key = keyOf(item)
    const last = groups[groups.length - 1]
    if (groupable && last && last.groupable && last.key === key) {
      last.items.push(item)
    } else {
      groups.push({ key, groupable, items: [item] })
    }
  })
  return groups
}
